export enum MaritalStatus_Enum {
  Married = 1,
  Cohabiting = 2,
  Single = 3,
  Divorced = 4,
  Seperated = 5,
  Widowed = 6,
  "Civil Partnership" = 7
}
